import classNames from "classnames"
import React from "react"
import CustomButton from "../Button"
import classes from "./CustomChip.module.css"

export type ChipVariant = "default" | "outlined"

export interface CustomChipProps {
  variant?: ChipVariant
  label: React.ReactNode
  disabled?: boolean
  onClick?: () => void
  className?: string
}

const CustomChip = ({
  label,
  onClick,
  disabled,
  variant,
  className,
}: CustomChipProps) => {
  return (
    <CustomButton
      onClick={onClick}
      variant="text"
      disabled={disabled}
      invariantCase
      classes={{
        button: classNames(classes.button, {
          [classes.buttonDefault]: variant === "default",
          [classes.buttonOutlined]: variant === "outlined",
          className,
        }),
        inner: classes.inner,
      }}
    >
      {label}
    </CustomButton>
  )
}

export default CustomChip
